import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { QueryState } from "@/shared/ui/QueryState";
import { useInternalAuditRecordDetailQuery } from "../api/queries";
import { InternalAuditRecordDetailView } from "../ui/InternalAuditRecordDetailView";

export function InternalAuditRecordDetailPage() {
  const { recordId } = useParams({
    from: "/app/internal-audit/record/$recordId",
  });
  const navigate = useNavigate();
  const query = useInternalAuditRecordDetailQuery(recordId, {
    enabled: Boolean(recordId),
  });

  if (query.isLoading) {
    return <QueryState isLoading>ກຳລັງໂຫຼດ...</QueryState>;
  }

  if (query.isError || !query.data) {
    return (
      <QueryState isError error={query.error}>
        ບໍ່ພົບບັນທຶກ ຫຼື ບໍ່ຢູ່ໃນຂອບເຂດຕຳແໜ່ງຂອງທ່ານ
      </QueryState>
    );
  }

  return (
    <>
      <Header />
      <InternalAuditRecordDetailView
        data={query.data}
        title="ລາຍລະອຽດບັນທຶກກວດສອບພາຍໃນ"
        onBack={() =>
          navigate({ to: "/app/internal-audit", search: { page: 1 } })
        }
      />
    </>
  );
}
